// extracted by mini-css-extract-plugin
export default {"edit-info":"additional-information_edit-info__htrnx"};